// extracted by mini-css-extract-plugin
module.exports = {"main":"ReasonTile_main_EDTJJ","mobile":"ReasonTile_mobile_18oMR","image":"ReasonTile_image_18umJ","text":"ReasonTile_text_30Ebf"};